import { DomainConfig } from './types';

import messageReducer from './slices/messageSlice';
import languageReducer from './slices/languageSlice';
import dynamicReducer from './slices/dynamicSlice';
import feedReducer from './slices/feedSlice';
import rolesReducer from './slices/rolesSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import userReducer from './slices/userSlice';
import authorizationReducer from './slices/authorizationSlice';
import notificationReducer from './slices/notificationSlice';

import configurationReducer from '../../domains/configuration/infrastructure/slices/configurationSlice';

import { userApi } from '../../services/user';
import { configurationApi } from '../../services/configuration';
import { systemApi } from '../../services/system';
import { subscriptionApi } from '../../domains/subscription/infrastructure/api/subscription.api';
import { settingsApi } from '../../domains/settings/infrastructure/api/settings.api';
import { clientsApi } from '../../domains/clients/infrastructure/api/clients.api';
import { stockOwnersApi } from '../../domains/clients/infrastructure/api/stock-owners.api';
import { channelsApi } from '../../domains/clients/infrastructure/api/channels.api';
import { notificationsApi } from '../../domains/notifications/infrastructure/api/notifications.api';
import { inboxApi } from '../../domains/inbox/infrastructure/api/inbox.api';
import { billingPlansApi } from '../../domains/billing/plans/infrastructure/api/plans.api';
import { billingPaymentOptionsApi } from '../../domains/billing/payment-options/infrastructure/api/payment-options.api';
import { billingWalletApi } from '../../domains/billing/wallet/infrastructure/api/wallet.api';
import { billingSubscriptionsApi } from '../../domains/billing/subscriptions/infrastructure/api/subscriptions.api';
import { legalPagesApi } from '../../domains/legal-pages/infrastructure/api/legalPages.api';
import { clientLegalContextApi } from '../../domains/legal-pages/infrastructure/api/clientLegalContext.api';
import { categoryApi } from '../../domains/category/infrastructure/api/category.api';
import { faqApi } from '../../domains/faq/infrastructure/api/faq.api';
import { changelogApi } from '../../domains/changelog/infrastructure/api/changelog.api';
import { legalApi } from '../../domains/legal/infrastructure/api/legal.api';

export const domainRegistry: DomainConfig[] = [
  { name: 'authorization', reducer: authorizationReducer },
  { name: 'user', reducer: userReducer },
  { name: 'message', reducer: messageReducer },
  { name: 'subscription', reducer: subscriptionReducer },
  { name: 'feed', reducer: feedReducer },
  { name: 'dynamic', reducer: dynamicReducer },
  { name: 'roles', reducer: rolesReducer },
  { name: 'language', reducer: languageReducer },
  { name: 'notification', reducer: notificationReducer },
  { name: 'configuration', reducer: configurationReducer },

  {
    name: userApi.reducerPath,
    reducer: userApi.reducer,
    middleware: [userApi.middleware],
  },
  {
    name: configurationApi.reducerPath,
    reducer: configurationApi.reducer,
    middleware: [configurationApi.middleware],
  },
  {
    name: systemApi.reducerPath,
    reducer: systemApi.reducer,
    middleware: [systemApi.middleware],
  },
  {
    name: subscriptionApi.reducerPath,
    reducer: subscriptionApi.reducer,
    middleware: [subscriptionApi.middleware],
  },
  {
    name: settingsApi.reducerPath,
    reducer: settingsApi.reducer,
    middleware: [settingsApi.middleware],
  },
  {
    name: clientsApi.reducerPath,
    reducer: clientsApi.reducer,
    middleware: [clientsApi.middleware],
  },
  {
    name: stockOwnersApi.reducerPath,
    reducer: stockOwnersApi.reducer,
    middleware: [stockOwnersApi.middleware],
  },
  {
    name: channelsApi.reducerPath,
    reducer: channelsApi.reducer,
    middleware: [channelsApi.middleware],
  },
  {
    name: notificationsApi.reducerPath,
    reducer: notificationsApi.reducer,
    middleware: [notificationsApi.middleware],
  },
  {
    name: inboxApi.reducerPath,
    reducer: inboxApi.reducer,
    middleware: [inboxApi.middleware],
  },
  {
    name: billingPlansApi.reducerPath,
    reducer: billingPlansApi.reducer,
    middleware: [billingPlansApi.middleware],
  },
  {
    name: billingPaymentOptionsApi.reducerPath,
    reducer: billingPaymentOptionsApi.reducer,
    middleware: [billingPaymentOptionsApi.middleware],
  },
  {
    name: billingWalletApi.reducerPath,
    reducer: billingWalletApi.reducer,
    middleware: [billingWalletApi.middleware],
  },
  {
    name: billingSubscriptionsApi.reducerPath,
    reducer: billingSubscriptionsApi.reducer,
    middleware: [billingSubscriptionsApi.middleware],
  },
  {
    name: legalPagesApi.reducerPath,
    reducer: legalPagesApi.reducer,
    middleware: [legalPagesApi.middleware],
  },
  {
    name: clientLegalContextApi.reducerPath,
    reducer: clientLegalContextApi.reducer,
    middleware: [clientLegalContextApi.middleware],
  },
  {
    name: categoryApi.reducerPath,
    reducer: categoryApi.reducer,
    middleware: [categoryApi.middleware],
  },
  {
    name: faqApi.reducerPath,
    reducer: faqApi.reducer,
    middleware: [faqApi.middleware],
  },
  {
    name: changelogApi.reducerPath,
    reducer: changelogApi.reducer,
    middleware: [changelogApi.middleware],
  },
  {
    name: legalApi.reducerPath,
    reducer: legalApi.reducer,
    middleware: [legalApi.middleware],
  },
];
